import React from "react";
import { Asterisk, AlertCircle } from "lucide-react";
import "./Label.css";
import { Tooltip, TooltipContent } from "./Tooltip";

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean;
  invalid?: boolean;
  invalidReason?: React.ReactNode;
};

export function Label({ className = "", required = false, invalid = false, invalidReason, children, ...props }: LabelProps) {
  return (
    <label className={`ds2-label ${className}`.trim()} {...props}>
      <span className="ds2-label-content">{children}</span>
      {required && (
        <span className="ds2-label-icon">
          <Asterisk size={12} />
        </span>
      )}
      {invalid && (
        <span className="ds2-label-icon ds2-label-icon-invalid">
          {invalidReason ? (
            <Tooltip>
              {[
                <span key="alert-icon-wrapper">
                  <AlertCircle size={12} />
                </span>,
                <TooltipContent key="tooltip-content">{invalidReason}</TooltipContent>
              ]}
            </Tooltip>
          ) : (
            <AlertCircle size={12} />
          )}
        </span>
      )}
    </label>
  );
}
